const en = {
  9000001: "2023 Christmas Trophy",
  9000002: "SuperEx Futures Championships",
  9000003: "Win 30,000 USDT in competition prize",
  9000004: "Number of Participants",
  9000005: "Unlocked Reward Pool (USDT)",
  9000006: "Trading Volume Ranking Qualifier",
  9000007: "Profit Rate Ranking Qualifying Competition",
  9000008: "Profit Ranking Qualifying Competition ",
  9000009: `Trading Volume Ranking Competition: Unlock the highest prize of <span style="color: #ffc72b;">20,000</span> USDT bonus pool. `,
  9000010: "According to the number of participants, the larger the number of participants, the larger the prize pool will be unlocked, up to 20,000USDT. ",
  9000011: "Reward Amount",
  9000012: "Updated at 10:00 (UTC) every day during the event",
  9000013: "Reward estimate ",
  9000014: "Cumulative Futures trading volume",
  9000015: "Reward Rules",
  9000016: "According to the number of participants, the larger the number of participants, the larger the prize pool will be unlocked, up to 20,000USDT. ",
  9000017: "Reward Amount (USDT)",
  9000018: "Event Profit Rate Ranking",
  9000019: "Register",
  9000020: "Event Profit Ranking",
  9000021: "Ended",
  9000022: `Profit Rate Ranking Contest - Enjoy <span style="color: #ffc72b;">{moneyPond}</span> USDT Bonus`,
  9000023: `Profit Ranking Competition - Enjoy <span style="color: #ffc72b;">{moneyPond}</span> USDT Bonus  `,
  9000024: "Cumulative Futures profit rate",
  9000025: "Futures Total Profits ",
  9000026: "Upcoming",
  9000027: "The top 50 participants in the Profit Ranking Competition will be rewarded. For details, please refer to the Ranking Reward Rules to get the rewards.",
  9000028: "The top 50 participants in terms of profitability will be rewarded, please refer to Trading Ranking Reward Rules to get the reward. ",
  9000029: "Event Trading Volume Ranking",
  9000030: "Registration successful",
  9000031: "Download the App",
  9000032: "Back to Home",

  //合约交易积分
  9100001: "Save Points",
  9100002: "Get Airdrop",
  9100003: "Redeem Rewards",
  9100004: "Points balance",
  9100005: "Details",
  9100006: "Sign-in points",
  9100007: "Trading Points",
  9100008: "Invitation points",
  9100009: "Bonus points",
  9100010: "Lucky draw",
  9100011: "Get points",
  9100012: "Points rules",
  9100013: "Points details",
  9100014: "You need to register to participate in this event. Click to register",
  9100015: "Have traded for {day} consecutive days and earned {num} points",
  9100016: "Points earned today {num}",
  9100017: "Points prize pool",
  9100018: "Each lucky draw consumes {point} points, and the maximum of {num} lucky draws times per day can be drawn.",
  9100019: "Number of lucky draws today",
  9100020: "User",
  9100021: "Points",
  9100022: "Points balance is insufficient",
  9100023: "Points balance is insufficient. Please get points before participating in the lucky draw.",
  9100024: "Number of lucky draws reached its limit!",
  9100025: "Number of lucky draws for today reached its limit. Try again tomorrow.",
  9100026: "How to get points",
  9100027: "Register to participate in the Futures trading point-earning activity to earn points.",
  9100028: "Successful registration",
  9100029: "You have signed up to participate in the Futures trading activity to earn points. Go and trade to earn more points (you will no longer enjoy the commission and cashback rewards)",
  9100030: "After canceling your registration, you will no longer receive points. Are you sure you want to cancel your registration?",
  9100031: "Trading Points Activity Center",
  9100032: "Get points",
  9100033: "You need to register to participate in this event. Click to register",
  9100034: "You can earn points by trading Futures continuously",
  9100035: "Users can earn points for all Futures tradings",
  9100036: "Leaderboard points",
  9100037: "Top five users in the daily trading rankings will receive additional bonus points",
  9100038: "Invited users receive points and the inviter can receive bonus points.",
  9100039: '{guy} Already won<span style="color:#D9A31A"> {num} points!</span>',
  9100040: "Try Lucky Draw Now!",
  9100041: "Congratulations on getting",
  9100042: "All types",
  9100043: "Stay on this page",
  9100044: "Register to particpate",
  9100045: "Continue trading",
  9100046: "There are no ongoing events at the moment. Please stay tuned for updates...",
  9100047: "and exchange them for SCS tokens",
  9100048: "",
  9100049: "",

  9100050: "Dates",
  9100051: "Select start date",
  9100052: "Select end date",
  9100053: "to",
  9100054: "Type",

  9100055: "Points earned = trading volume * 1% (the difficulty will be further adjusted as the total trading volume of the platform increases)",
  9100056: "For example: the user uses a position with a margin of 100 USDT*100X=10000 USDT",
  9100057: "Then you only need a deposit of 100 USDT to get 100 points",
  9100058: "Trading points are the only way to obtain the platform token SCS",
  9100059: "Extra bonus points = total points for the day * ranking reward ratio",
  9100060: "Ranking",
  9100061: "First place",
  9100062: "Second place",
  9100063: "Third place",
  9100064: "Fourth place",
  9100065: "Fifth place",
  9100066: "Invited users receive points and the inviter can receive bonus points.",
  9100067: "Level factor ",
  9100068: "Calculation formula: referral points obtained = points obtained by the invitee * level coefficient",
  9100069: "The level coefficient will be adjusted according to the actual situation",
  9100070: "For example: User B participates in a points activity, and its inviter is User A, and the number of invitations from User A has reached Level 3. User B has accumulated points = 360,000;",
  9100071: "Then the cumulative promotion points that user A can obtain = 360000* 30% = 108,000",
  9100072: "Reward coefficient ",
  9100073: "1 Trading users ",
  9100074: "The trading volume reaches 5 million ",
  9100075: "The trading volume reaches 20 million ",

  9100076: "Transfer",

  //热币
  9100080: "Ended",
  9100081: "Click ‘Join Now’ to win rewards",
  9100082: "View Rules",
  9100083: "Join Now",
  9100084: "Activity",
  9100088: "Trade",
  9100089: "Deposit",
  9100090: "You have already registered",

  9100091: "This event has ended, please look forward to the next event!",
  9100092: "The event has not started yet, please stay tuned.",
  9100093: "",
  9100094: "",

  //api key
  9100105: "Create API Key",
  9100106: "View API Documentation",
  9100107: "Integrated trading system",
  9100108: "Create/Manage API Key",
  9100109: "Deploy API",
  9100110: "Trading and Requests",
  9100111: "A leading digital asset trading platform",
  9100112: "A wide range of digital asset trading and asset management services to meet diverse trading needs.",
  9100113: "Providing better services",
  9100114: "More favorable trading fees, higher trading amounts, more flexible account management functions, etc.",
  9100115: "The choice of millions of users",
  9100116: "Ensuring a safe trading environment, providing professional customer support, helping you advance steadily in the world of digital assets.",
  9100117: "How to create an API Key at SuperEx?",
  9100118: `Where can I view SuperEx's API documentation?`,
  9100119: "Encountering issues with SuperEx trading, what should I do?",
  9100120: "How to use SuperEx’s API?",
  9100121: "Access the SuperEx API for faster and smoother trading",
  9100122: `When logged in, hover over the avatar - 'API Management' and click 'Create API Key' to create your API Key at SuperEx. Note: If you are not logged in, you need to log in to your SuperEx account first.
You can also create your API Key from the 'APIs' link in the bottom navigation bar.`,
  9100123: 'You can click <a style="color:#d1a53e;text-decoration:underline !important;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;" href="https://docs-api.superex.com/en/quickStart.html">API Documentation</a> to view SuperEx’s API documentation.',
  9100124: 'If you encounter any issues or have suggestions during use, you can contact us in the following ways: <br>Contact customer service through the "Help Center" on the official website or by sending an email to support@superex.com.',
  9100125: `To use SuperEx's API, you first need to:<br>Register and log into your SuperEx account.<br>Create an API Key, which will generate an access_key and secret_key for you.<br>Use this access_key and secret_key to sign your requests.<br>Depending on your needs, you can utilize various APIs provided by SuperEx, such as Market Data API, Trading API, and Account API.<br>Ensure each request follows the instructions in the API documentation, with proper HTTP headers and signatures.<br>`,
  9100126: "Action",
  9100127: "Create New API Key",
  9100128: "API Key Name",
  9100129: "Please enter an API Key name",
  9100130: "Permissions(Multiple choice)",
  9100131: "Read",
  9100132: "Trade",
  9100133: "IP address allowlist (optional)",
  9100134: "You can link up to 10 IP addresses to each API key, separated by commas.",
  9100135: "I have read and agree to",
  9100136: "I have read and agree to the API User Risk Notice",
  9100137: "Create",
  9100138: 'SuperEx provides you with a powerful API that allows you to use services such as market query and automatic trading. See how to use it by viewing the <a style="color:#0052D9;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;text-decoration:underline !important;color:#d1a53e;" href="https://docs-api.superex.com/en/quickStart.html">API Documentation</a>.',
  9100139: "Each account can create up to 10 API Keys.",
  9100140: `API Keys that are not linked to an IP will automatically expire after 90 days. If you intend to use it for a long time, you can renew your API Key under 'My API Key' — 'Action' — 'Renew', extending the validity period for another 90 days. API Keys linked to IPs do not have an expiration limit.`,
  9100141: "My API Key",
  9100142: "Permissions",
  9100143: "IP Address",
  9100144: "Renew",
  9100145: "Creating an API Key requires you to deposit any amount into your spot wallet to activate your account",
  9100146: "Confirm renewal of current API Key",
  9100147: "Do not disclose your Access Key and Secret Key to avoid asset loss.",
  9100148: "For security reasons, it is recommended to link API keys to specific IP addresses. An API Key can be linked to a maximum of 20 IP addresses or IP segments. You may input a single IP address or multiple addresses directly, and separate different addresses with a comma. For example: 192.168.1.1,192.168.1.2",
  9100149: "After a successful renewal, the expiration date will be recalculated. If you use the API Key long-term, it is recommended to link an IP address. Bound API Keys will not expire and are also more secure.",
  9100150: "Confirm deletion of current API Key?",
  9100151: "You need to understand the following risks:",
  9100152: "Your API Key is closely related to the security of your account. Anyone who knows your API Key could potentially control your account assets. Therefore, please safeguard it properly, do not disclose your API Key to any third parties, and do not upload it to third-party websites or forums.",
  9100153: "If your API Key is leaked due to personal reasons, including but not limited to asset security and economic losses, you shall bear all the responsibilities arising therefrom, and we will not assume any responsibility.",
  9100154: "Risk Notice",
  9100155: "I am aware and willing to take on the risk.",
  9100156: "Saved",
  9100157: "Permissions",
  9100158: "The Secret Key is only displayed once and cannot be retrieved if lost, please keep it safe.",
  9100159: "Do not disclose your Access Key and Secret Key to avoid asset loss.",
  9100160: "If you forget your Secret Key, please delete this key pair and apply for a new one.",
  9100161: "We offer powerful APIs to help you efficiently integrate trading features into your applications. APIs are categorized into Account, Trading, and Market Data, allowing you to configure necessary permissions and implement automated trading via API.",
  9100162: "Listing Time",
  9100163: "Create New API Key",
  9100164: "Edit",
  9100165: "Maturity date",
  9100166: "Delete",
  9100167: "Creation successful",
  9100168: "Tips",
  9100169: "Okay",
  9100170: "API User Risk Notice",
  9100171: "Incorrect IP address format",
  9100172: "",
  //自由区二维码分享页面
  91000951: "Spot Meme, a crypto world of the users, by the users, for the users",
  91000961: "Open the app",
  //自由区二维码分享页面
  9100095: "SuperEx Free Market, a crypto world of the users, by the users, for the users",
  9100096: "Open the app",
  9100097: "",
  9100098: "",

  //代理商
  101738: "Become a SuperEx agent and enjoy high commissions!",
  101739: "Invite your friends to trade with SuperEx and get 50% of the commission. Start earning commissions after your referrals trade contracts.",
  101740: "Become an agent",
  101741: "How do I get commissions?",
  101742: "Apply to become an agent",
  101743: "If you have community, media following and other resources, you can apply to become an agent, and after a successful application, you can upgrade to an agent.",
  101744: "Promote SuperEx",
  101745: "Share your invite link with your community, followers or your other channels for promotional exposure",
  101746: "Get commission",
  101747: "You can earn commissions when new users sign up and trade through your invitation link.",
  101748: "How much commission can I earn?",
  101749: `When you invite users to trade with SuperEx, you get 20% of your friend's commission as an invitation bonus.`,
  101750: "If you become a SuperEx agent, you will also receive a 50% agent bonus. ",
  101751: "Why become a SuperEx agent?",
  101752: "High commission",
  101753: "50% commission rebate",
  101754: "User Traffic Support",
  101755: "Professional traffic support, easy access to revenue",
  101756: "Branding Support",
  101757: "Global offline events with customized gift peripheral",
  101758: "Global offline events",
  101759: `SuperEx global offline fan meeting, industry's top meetings, and all-round support for each agent, to help them enhance their earnings!`,
  101760: "Review failed",
  101761: "Agents",
  101762: "Channel Management",
  101763: "Create Channel",
  101764: "Affiliated Channels",
  101765: "Promotion Method",
  101766: "Channel Name",
  101767: "Created",
  101768: "Edit",
  101769: "Futures rebate ratio",
  101770: "Spot rebate ratio",
  101771: "Promotion Management",
  101772: "Invitation code",
  101773: "Invitation code",
  101774: "Remaining number of referral links can be created",
  101775: "Friends",
  101776: "Agent invitation code",
  101777: "Agents number of referrals",
  101778: "Regular invitation codes",
  101779: "Regular number of referrals",
  101780: "Invitation link",
  101781: "Regular Channels",
  101782: "Data Board",
  101783: "Deposits",
  101784: "Transaction amount",
  101785: "Commission",
  101786: "Invitation Code",
  101787: "Mobile Invitation Relationship",
  101788: "Contract Reports",
  101789: "Spot Reports",
  101790: "Transactions",
  101791: "Settlement Center",
  101792: "Contract Settlement",
  101793: "Spot Settlement",
  101794: "Estimated Commission",
  101795: "Withdrawal Record",
  101796: "View Assets",
  101797: "Withdrawn Amount",
  101798: "Accumulated Commission",
  101799: "Current tokens do not meet the withdrawal amount. You can invite more users to trade to get bonus money.",
  101800: "Contract Data Overview",
  101801: "Spot Data Overview",
  101802: "Contract Details",
  101803: "Spot Details",
  101804: "All Direction",
  101805: "Agent Estimated Commission",
  101806: "User Estimated Commission",
  101807: "Transaction Time",
  101808: "For detailed rules, please check the SuperEx announcement.",
  101809: "Agent Program Application Form",
  101810: "Your language",
  101811: "Which country are you in? (Example: Iran)",
  101812: "What is your main platform/channel?",
  101813: "How many followers/fans/users do you have on your platform/social media/website?",
  101814: "Fill in your main platform/channel link (enter full URL)",
  101815: "Other social channels/website links (enter full URL)",
  101816: "Your name",
  101817: "Fill in the social media channels to contact you quickly (e.g. Telegram id @xxx)",
  101818: "Where did you learn about the agent program?",
  101819: "Friend",
  101820: "Additional information you can share with us, such as about yourself and a brief introduction to your channel",
  101821: "Great!",
  101822: "You have successfully completed the SuperEx agent application. After passing the review, we will notify you via email.",
  101823: "The time period cannot be more than a 3-month span.",
  101824: "Success",
  101825: "All withdrawals",
  101826: "Withdrawn",
  101827: "Current tokens do not meet the withdrawal amount. You can invite more users to trade to get bonus money.",
  101828: "User Management",
  101829: "User ID",
  101830: "Futures Rebate Ratio",
  101831: "Spot Rebate Ratio",
  101832: "Registration Time",
  101833: "Transaction Details",
  101834: "Buy Long",
  101835: "Sell Short",
  101836: "Sell Long",
  101837: "Buy Short",
  101838: "Withdrawal Time",
  101839: "Withdrawal currency",
  101840: "Number of withdrawals",
  101841: "Commission",
  101842: "Withdrawable Amount",
  101843: "Withdrawal",
  101844: "Community",
  101845: "Email (this email will be used to receive agent information, please check your spam email if no verification message is found)",
  101846: "Verification Code",
  101847: `Be patient as we are reviewing your application. We will notify you when it's approved with email.`,
  101848: "Sorry, your agent application was not approved",
  101849: "Re-apply",
  101850: "Data Overview",
  101851: "Agents contract commission rate",
  101852: "Agents spot commission rate",
  101853: "You have been disqualified as an agent, if you have any questions please contact the administrator",
  101854: "All Time",
  101855: "Yesterday",
  101856: "This Month",
  101857: "Last Month",
  101858: "Number of Traders",
  101859: "Total Deposit",
  101860: "Select the invitation code",
  101861: "Gross earnings",
  101862: "Futures Commission",
  101863: "Spot Commission",
  101864: "Pending",
  101865: "Withdrawn",
  101866: "To be unlocked",
  101867: "*Commission earnings need to be withdrawn to My Spot Account to be used.",
  101868: "Withdrawal Confirmation",
  101869: "Are you sure you want to withdraw all tokens to my Spot account?",
  101870: "Current tokens do not meet the withdrawal amount. You can invite more users to trade to get bonus money.",
  101871: "Unlocked",
  101872: "Reversed",
  101873: "Agent qualification cancelled",
  101874: "Already an agent",
  101875: "Channel Data Overview",
  101876: "User Data",
  101877: "To cloud wallet Futures account",
  101878: "To Cloud Wallet Spot Account",
  101879: "Spot Trading Details",
  101880: "Futures Trading Details",
  101881: "Futures Settlement Center",
  101882: "Spot Settlement Center",
  101883: "Effectiveness Report",
  101884: "Select language",
  101885: "Enter your answer",
  101886: "Select the channel name",
  101887: "Commission Withdrawal",
  101888: "Enter the channel name",
  101889: "Select the promotion method",
  101890: "Enter notes",
  101891: "Assets available for withdrawal",
  101892: "Confirm withdrawal",
  101893: "Set user Futures rebate ratio",
  101894: "Set user Spot rebate ratio",
  101895: "Futures Performance Report",
  101896: "Spot Performance Report",
  101897: "Conversion (USDT)",
  101898: "Withdrawal to Cloud Wallet",
  101899: "Are you sure you want to withdraw all your spot commissions to your cloud wallet?",
  101900: "View Funds",
  101901: "All currencies",
  101902: "Unwithdrawn",
  101903: "Total Commission",
  101904: "Please select a country or region",
  101905: "Enter the verification code",
  101906: "Agent system",
  101907: "Thank you.",
  101908: "Your application has been sent. We usually review your information within 2-3 business days, and your commission will be effective after passing the review!",

  //代理商拉新
  92000000:'Event countdown',
  92000001:'Participation method',
  92000002:'You need to ensure the account completing the task matches your registered/login account on the current page to have a chance to earn rewards.',
  92000003:'Waiting for task verification',
  92000004:'Register at SuperEx by invite from <span style="color:#000922;font-weight:500;">{brokerName}</span> to unlock limited-time welcome bonus!',
  92000005:'Start from {time}',
  92000006:'Complete by {time}',
  92000007:'Task completion verification may take up to 7 business days, please be patient.',
  92000008:'About 7 days after the event',
  92000009:'The reward will be distributed to the account within 7 working days after event validation.',
  92000010:`Register using <span style="color:#000922;font-weight:400;">{brokerName}</span>'s invite link`,
  92000011:'Terms and conditions',
  92000012:'Event in progress',
  92000013:'Unable to participate in this event',
  92000014:'Event ended',
  92000015:'Claim Reward',
  92000016:'Log in now',
  92000017:'Please set a nickname',

  92000018:'Remarks',
  92000019:'This item is required',
  92000020:'Save',
  92000021:'Share poster',
  92000022:'Max',
  92000023:'Edit channel',
  92000024:'Create channel',
  92000025:'No invitation code in this channel',
  92000026:'',
  92000027:'',
  92000028:'',
  92000029:'',
  92000030:'',
};
export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/en.js